import React from 'react';

import Card from '../../atoms/Card';
import Grid from '../../atoms/Grid';

import { GinieReceptionContent, GinieReceptionContentsDetail } from '../../../external/CustomerInfoAllApi';

import ReceptionContentsTable from '../ReceptionContentsTable';

export interface GinieReceptionContentsTableProps {
  data: GinieReceptionContent[];
}

const getFormNumbersAsString = (data: GinieReceptionContentsDetail[]): string => {
  if (data.length === 0) {
    return '';
  }
  return [...data]
    .sort((a, b) => (a.ginieApplicationFormNumber > b.ginieApplicationFormNumber ? 1 : -1))
    .map((v) => v.ginieApplicationFormNumber)
    .join('\n');
};

const GinieReceptionContentsTable: React.FC<GinieReceptionContentsTableProps> = ({ data }) => {
  return (
    <>
      {[...data]
        .sort((a, b) => (a.ginieReceptionNumber > b.ginieReceptionNumber ? 1 : -1))
        .map((item) => {
          return (
            <Card className='u-mb24' key={`${item.ginieReceptionNumber}`}>
              <Card.Content>
                <Grid>
                  <Grid.Row>
                    <Grid.Col colS={12} colM={12} colL={12} className='u-mb8'>
                      <span
                        className='u-text-secondary u-text-bold'
                        data-testid='ginie-reception-number-label'
                        data-testid-e2e='ginie-reception-number-label'>
                        受付番号
                      </span>
                      <p
                        className='report-cards__item-title'
                        data-testid='ginie-reception-number-value'
                        data-testid-e2e='ginie-reception-number-value'>
                        {item.ginieReceptionNumber}
                      </p>
                    </Grid.Col>
                    <Grid.Col colS={12} colM={12} colL={12} className='u-mb8'>
                      <span
                        className='u-text-secondary u-text-bold'
                        data-testid='ginie-business-type-name-label'
                        data-testid-e2e='ginie-business-type-name-label'>
                        受付内容
                      </span>
                      <p
                        className='report-cards__item-title'
                        data-testid='ginie-business-type-name-value'
                        data-testid-e2e='ginie-business-type-name-value'>
                        {item.businessTypeName}
                      </p>
                    </Grid.Col>
                    <Grid.Col colS={12} colM={12} colL={12} className='u-mb8'>
                      <span
                        className='u-text-secondary u-text-bold'
                        data-testid='ginie-application-form-number-label'
                        data-testid-e2e='ginie-application-form-number-label'>
                        申込書番号
                      </span>
                      <p
                        className='report-cards__item-title'
                        data-testid='ginie-application-form-number-value'
                        data-testid-e2e='ginie-application-form-number-value'>
                        {getFormNumbersAsString(item.receptionContentsDetail)}
                      </p>
                    </Grid.Col>
                    <ReceptionContentsTable
                      dataType={'ginie'}
                      acceptedDateTime={item.acceptedDateTime}
                      registrationCrewCode={item.registrationCrewCode}
                      registrationCrewName={item.registrationCrewName}
                      customerCrewCode={item.customerCrewCode}
                      customerCrewName={item.customerCrewName}
                    />
                  </Grid.Row>
                </Grid>
              </Card.Content>
            </Card>
          );
        })}
    </>
  );
};

export default GinieReceptionContentsTable;
